import { Component, OnInit, Input, ViewEncapsulation, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataFieldDefinition, DataRecordDefinition } from '../dynamic/dynamic';
import { ContextService } from '../context.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

declare var CodeMirror: any;
@Component({
  selector: 'mutara-data-editor',
  templateUrl: './data-editor.component.html',
  styleUrls: ['./data-editor.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class DataEditorComponent implements OnInit {
  @ViewChild('textarea') ta: HTMLTextAreaElement | undefined;
  @Input() recordName: string | undefined
  recordDefinitions: DataRecordDefinition[] = [];
  viewDefinitions: DataRecordDefinition[] = [];
  fields: any[] = [];
  boundLists: string[] = [];

  constructor(private http: HttpClient,
    private context: ContextService,
    //    private dialogRef: MatDialogRef<DataEditorComponent>,
    //    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    let cm = new CodeMirror.fromTextArea(this.ta);
    this.context.subscribeTo("dropListTargets", (context : string[]) => {
      this.boundLists = context;
    });

    this.http.get('$service/form', { params: { record: "RECORD_LIST" } }).subscribe({
      next: (results : any)=> {
        results['data'].forEach((definition: DataRecordDefinition) => {
          (definition.recordType == 'View' ? this.viewDefinitions : this.recordDefinitions).push(definition);
        });
      }
    });
  }
  /*
    close() {
      this.dialogRef.close();
    }
    */
  getFields(record: DataRecordDefinition): DataFieldDefinition[] {
    let defs: DataFieldDefinition[] = [];
    Object.entries(record).forEach( ([, value]) =>  defs.push(value));
    return record.fields;
  }

  drop(event: Event ) {
    console.log('editor %O', event);

    // if (event.previousContainer === event.container) {
    //   moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    // } else {
    //   console.log(event.previousContainer.data);
    //   transferArrayItem(event.previousContainer.data,
    //     event.container.data,
    //     event.previousIndex,
    //     event.currentIndex);
    // }
  }

  newRecord() {
    console.log('new record');
  }
}
